import { GiftTheme } from 'models/gift.model';
import { CountryCode } from '@prezzee/ribbon-ui/lib/components/FormInputPhoneNumber/countries';
import { Nullable } from './types';

export type PurchaseKind = 'user' | 'guest';
export type PurchaseType = 'self' | 'friend';
export type PurchaseMethodId = 'applePay' | 'googlePay' | 'paypal' | 'creditCard' | null;

export type Step = {
  subtitle?: string;
  disabled: boolean;
  hidden: boolean;
  component: JSX.Element;
  ref: React.RefObject<HTMLElement>;
  index: number;
};

export type Steps = 'Choose' | 'Wrap' | 'Send' | 'Preview' | 'Pay';

export type Promo = {
  promoCode: string;
  promoCodeName: string;
  promoCodeValue: string;
};

export type PickSectionInputs = {
  value: string;
  previousValue?: string;
  purchaseType: PurchaseType;
};

export type GiftMedia = {
  uid: string;
  accountId: string;
  videoId: string;
  playerId: string;
};

export type GiphyItem = {
  id: string;
  url: string;
};

export type WrapSectionInputs = {
  // Tabs
  giftCardDesignTab?: boolean;
  giftMediaTab?: boolean;
  personaliseMessageTab?: boolean;
  // Inputs
  themeUid?: string;
  customThemeUid?: string;
  giftMedia?: GiftMedia;
  giftTheme?: GiftTheme;
  giphy?: GiphyItem;
  message?: string;
};

export type Recipient = {
  name: string | null;
  email?: string | null;
  phone?: {
    countryCode: CountryCode | null;
    number: string;
    type: string;
  } | null;
  smsCheckbox: boolean;
  emailCheckbox: boolean;
};

export type DeliverSectionInputs = {
  recipients: Recipient[];
  deliveryOption?: string;
  scheduledTimeZone?: string;
  scheduledDate?: string;
  scheduledDeliveryAt?: string;
  scheduledTime?: string;
  guestEmail: string | null;
  guestFirstName: string | null;
  guestLastName: string | null;
  guestPassword?: string;
  senderAlias: string | null;
  senderMobile?: string;
};

export type PaymentSummaryInputs = {
  prezzeeEDM: boolean;
  prezzeeTnC: boolean;
  nzTnC: boolean;
  paymentMethodId: PurchaseMethodId;
  promo: Nullable<Promo>;
};

export type UIOnlyInputs = {
  giftCardDesign: boolean;
  giftMedia: boolean;
  personaliseMessage: boolean;
};

export type ProductFormInputs = PickSectionInputs & WrapSectionInputs & DeliverSectionInputs & PaymentSummaryInputs;

export type Order = {
  orderNumber: string;
  status: string;
};

export enum STEP {
  CHOOSE = 0,
  WRAP = 1,
  SEND = 2,
  PREVIEW = 3,
  PAY = 4,
}
